import { useAdminDispatch } from 'admin/reducers';
import MediaField from 'admin/components/common/Form/MediaField';
import { TextField } from 'admin/components/common/Form';
import { Flex } from 'antd';
import css from './BrandResourcesEditor.scss';
import type { AssetUpload } from './index';

export default function AssetField({
	id,
	value,
	onChange,
	onUpload,
	onBusyChange,
	theme,
}: {
	id: string;
	value: string;
	onChange: (url: string) => void;
	onUpload: AssetUpload;
	onBusyChange: (busy: boolean) => void;
	theme: 'light' | 'dark';
}) {
	const dispatch = useAdminDispatch();
	const error = MediaField.errorsMsg[value as keyof typeof MediaField.errorsMsg];
	return (
		<Flex vertical gap="medium">
			<MediaField
				className={css.assetMediaField}
				label="Image"
				theme={theme}
				previewSize="contain"
				showInfo={false}
				onBusyChange={onBusyChange}
				input={{
					value,
					name: id,
					onChange: event => onChange(typeof event === 'string' ? event : event.target.value),
					onBlur: () => {},
					onFocus: () => {},
					onDragStart: () => {},
					onDrop: () => {},
				}}
				meta={{
					active: false,
					asyncValidating: false,
					autofilled: false,
					dirty: false,
					dispatch,
					error,
					form: 'brand-resources',
					initial: value,
					invalid: !!error,
					pristine: true,
					submitting: false,
					submitFailed: false,
					touched: true,
					valid: !error,
					visited: false,
				}}
				eventListeners={{ onUpload: ({ asset }) => onUpload(asset) }}
			/>
			<TextField
				theme={theme}
				aria-label="Image URL"
				placeholder="https://"
				value={error ? '' : value}
				onChange={event => onChange(event.target.value)}
			/>
		</Flex>
	);
}
